import {
  Collapse,
  darken,
  Divider,
  lighten,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import React from "react";
import { ExpandLess, ExpandMore, Logout } from "@mui/icons-material";
import routeTitleMapObject from "../../helpers/routeTitleMapObject";
import { logout } from "../../redux/slice/auth";
import {
  isVisible,
  managementGroup,
  MenuLeaf,
  reportsGroup,
  shipperBeneficiaryItems,
  topLevelItems,
} from "./menuConfig";

const getBackgroundColor = (color: string, mode: string) =>
  mode === "dark" ? darken(color, 0.6) : lighten(color, 0.9);

const getHoverBackgroundColor = (color: string, mode: string) =>
  mode === "dark" ? darken(color, 0.5) : lighten(color, 0.8);

export const menuItems = (
  openReports: any,
  openManagement: any,
  handleOpenReports: AnyFunction,
  handleOpenManagement: AnyFunction,
  setTitle: AnyFunction,
  navigate: (path: string) => void,
  dispatch: AnyFunction,
  isAdmin: any,
  isAdminOrManager: any,
  isShipperBeneficiary: boolean,
  currentPath?: string
) => {
  const goTo = (path: string) => {
    setTitle(routeTitleMapObject[path]);
    navigate(path);
  };

  const renderTopLeaf = (leaf: MenuLeaf) => {
    const Icon = leaf.icon;
    return (
      <ListItemButton
        key={leaf.path}
        selected={leaf.path === currentPath}
        onClick={() => goTo(leaf.path)}
      >
        <ListItemIcon>
          <Icon />
        </ListItemIcon>
        <ListItemText primary={leaf.label} />
      </ListItemButton>
    );
  };

  const renderSubLeaf = (leaf: MenuLeaf) => {
    const Icon = leaf.icon;
    return (
      <ListItemButton
        key={leaf.path}
        selected={leaf.path === currentPath}
        onClick={() => goTo(leaf.path)}
        sx={{
          backgroundColor: (theme) =>
            getBackgroundColor(theme.palette.grey[800], theme.palette.mode),
          "&&:hover": {
            backgroundColor: (theme) =>
              getHoverBackgroundColor(
                theme.palette.grey[800],
                theme.palette.mode
              ),
          },
        }}
      >
        <ListItemIcon>
          <Icon />
        </ListItemIcon>
        <ListItemText primary={leaf.label} />
      </ListItemButton>
    );
  };

  if (isShipperBeneficiary) {
    return (
      <>
        {shipperBeneficiaryItems.map(renderTopLeaf)}
        <ListItemButton onClick={() => dispatch(logout())}>
          <ListItemIcon>
            <Logout />
          </ListItemIcon>
          <ListItemText primary="Deconectare" />
        </ListItemButton>
      </>
    );
  }

  const ReportsIcon = reportsGroup.icon;
  const ManagementIcon = managementGroup.icon;

  const visibleReports = reportsGroup.children.filter((leaf) =>
    isVisible(leaf.role, isAdmin, isAdminOrManager)
  );
  const visibleManagement = managementGroup.children.filter((leaf) =>
    isVisible(leaf.role, isAdmin, isAdminOrManager)
  );

  return (
    <React.Fragment>
      {topLevelItems.map(renderTopLeaf)}
      <ListItemButton onClick={handleOpenReports}>
        <ListItemIcon>
          <ReportsIcon />
        </ListItemIcon>
        <ListItemText primary={reportsGroup.label} />
        {openReports ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      {openReports ? <Divider /> : <></>}
      <Collapse in={openReports} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {visibleReports.map(renderSubLeaf)}
        </List>
      </Collapse>
      {openReports ? <Divider /> : <></>}
      <ListItemButton onClick={handleOpenManagement}>
        <ListItemIcon>
          <ManagementIcon />
        </ListItemIcon>
        <ListItemText primary={managementGroup.label} />
        {openManagement ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      {openManagement ? <Divider /> : <></>}
      <Collapse in={openManagement} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {visibleManagement.map(renderSubLeaf)}
        </List>
      </Collapse>
      {openManagement ? <Divider /> : <></>}
      <ListItemButton onClick={() => dispatch(logout())}>
        <ListItemIcon>
          <Logout />
        </ListItemIcon>
        <ListItemText primary="Deconectare" />
      </ListItemButton>
    </React.Fragment>
  );
};
